const CANVAS_WIDTH = 1280
const CANVAS_HEIGHT = 800
const BASE_FONT_SIZE = 16
const DEFAULT_HEIGHT = 50
const DEFAULT_WIDTH = 100

export {CANVAS_WIDTH, CANVAS_HEIGHT, BASE_FONT_SIZE, DEFAULT_HEIGHT, DEFAULT_WIDTH}
